import {
	GET_OFFERS_DATA,
	GET_OFFERS_DATA_SUCCESS,
	GET_OFFERS_DATA_FAILURE,
	GET_ARTICLES_DATA,
	GET_ARTICLES_DATA_SUCCESS,
	GET_ARTICLES_DATA_FAILED,
	DELETE_ARTICLE_AND_FAQS,
} from "../Types/dashboard";
import { CALL_API } from "../api.middleware";
import { LOGOUT_SUCCESS } from "../Types";
import { CLIENT_NAME } from "../../constants";

export const getOffersData = () => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/catalog/offers?clientName=${CLIENT_NAME}`,
				method: "GET",
				types: [GET_OFFERS_DATA, GET_OFFERS_DATA_SUCCESS, GET_OFFERS_DATA_FAILURE],
				showLoader: true,
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Dash - 25", error);
	}
};

export const getArticlesData =
	(params = {}) =>
	async (dispatch) => {
		try {
			return await dispatch({
				[CALL_API]: {
					url: `/catalog/articles`,
					method: "GET",
					types: [GET_ARTICLES_DATA, GET_ARTICLES_DATA_SUCCESS, GET_ARTICLES_DATA_FAILED],
					showLoader: true,
					params,
				},
			});
		} catch (error) {
			// alert(`${error}`);
			console.error("Dash - 44", error);
		}
	};

export const deleteArticleAndFAQs = () => {
	return {
		type: DELETE_ARTICLE_AND_FAQS,
	};
};

export function logout() {
	return {
		type: LOGOUT_SUCCESS,
	};
}
